import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';

export interface ShopifyCollectionDto {
  CollectionId: number;
  ShopifyCollectionId: number;
  Title: string;
  Description: string;
  CollectionType: string;
  ProductsCount: number;
  IsActive: boolean;
  CreatedDate: string;
}

export interface ShopifyCollectionStoreMappingDto {
  ShopifyCollectionStoreMappingId: number;
  CollectionId: number;
  StoreId: number;
  StoreName: string;
  IsActive: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class ShopifyCollectionService {

  private readonly baseUrl = environment.baseUrl;

  constructor(private http: HttpClient) { }

  getCollections(): Observable<any> {
    return this.http.get<any>(
      `${this.baseUrl}/ShopifyCollection/GetAll`
    );
  }

  getStoreCollectionId(storeId: number): Observable<any> {
    return this.http.get<any>(
      `${this.baseUrl}/ShopifyCollection/GetStoreCollectionId?storeId=${storeId}`
    );
  }

  getCollectionById(id: number): Observable<any> {
    return this.http.get<any>(
      `${this.baseUrl}/ShopifyCollection/GetById/${id}`
    );
  }

  syncCollections(request: SyncCollectionsRequest): Observable<any> {
    return this.http.post<any>(
      `${this.baseUrl}/ShopifyCollection/Sync`,
      request
    );
  }

  getStoresWithUsers(): Observable<any> {
    return this.http.get<any>(
      `${this.baseUrl}/ShopifyCollection/GetStoresWithUsers`
    );
  }

  assignCollection(request: AssignCollectionRequest): Observable<any> {
    return this.http.post<any>(
      `${this.baseUrl}/ShopifyCollection/AssignCollection`,
      request
    );
  }

  toggleCollectionStatus(request: ToggleCollectionStatusRequest): Observable<any> {
    return this.http.post<any>(
      `${this.baseUrl}/ShopifyCollection/ToggleStatus`,
      request
    );
  }

  removeCollection(request: RemoveCollectionRequest): Observable<any> {
    return this.http.post<any>(
      `${this.baseUrl}/ShopifyCollection/RemoveCollection`,
      request
    );
  }

  getCollectionSeoUrls(storeId: number): Observable<any> {
    return this.http.get<any>(
      `${this.baseUrl}/ShopifyCollection/GetCollectionSeoUrls?storeId=${storeId}`
    );
  }
}

export interface SyncCollectionsRequest {
  storeId: number;
  userId: number;
}

export interface AssignCollectionRequest {
  storeId: number;
  collectionId: number;
  userId: number;
}

export interface ToggleCollectionStatusRequest {
  collectionId: number;
  isActive: boolean;
  userId: number;
}

export interface RemoveCollectionRequest {
  storeId: number;
  userId: number;
}

export interface StoreUserDto {
  StoreId: number;
  StoreName: string;
  UserId: number;
  FirstName: string;
  LastName: string;
  Email: string;
  AssignedCollectionId: number | null;
  AssignedCollectionTitle: string | null;
}
